import { DecimalPipe } from '@angular/common';
import { LOCALE_ID, Pipe,Inject } from '@angular/core';
import { QuantityFormatsService } from '~/services/administration.ts/quantity-formats';

@Pipe({
    name: 'quantityFormat',
    standalone: false
})
export class QuantityFormatPipe extends DecimalPipe {

  _model: any;

  constructor(@Inject(LOCALE_ID) locale: string,
  private _quantityFormatsService: QuantityFormatsService) {
  super(locale);
}

transform(val: any, args?: any): any {
  if(!isFinite(val) || val=='')
    val = 0;
   let quantityFormat=this._quantityFormatsService.quantityFormat;
    return super.transform(val,quantityFormat);
};


}


